export default (phone?: string | undefined, extension?: string | null) => {
  if (!phone) {
    return `tel:${phone}`;
  }

  // The format for a clickable tel: link
  // No country code: "tel:(999) 999-9999"
  // Wt country code: "tel:+1(999) 999-9999"
  // Added Extension: "tel:(999) 999-9999,9999"

  const formatted = phone
    .trim()
    .match(/^(\+1|1)?\D*(\d{3})\D*(\d{3})\D*(\d{4})/);

  const formattedExt = phone.trim().match(/x(\d{0,4})$/);

  const ext =
    extension !== undefined ? extension : formattedExt ? formattedExt[1] : '';

  if (formatted) {
    const countryCode = formatted[1] ? `${formatted[1]} ` : '';

    const phoneLink = ext
      ? `tel:${countryCode}(${formatted[2]}) ${formatted[3]}-${formatted[4]},${ext}`
      : `tel:${countryCode}(${formatted[2]}) ${formatted[3]}-${formatted[4]}`;

    return phoneLink;
  }

  return `tel:${phone}`;
};
